// Updated: 2026-08-21 09:34:00 CDT
// Purpose: Keep every requested screenplay block playable by filling missing assignments with the selected preview voice.

import type { Character } from "@/types/screenplay";

export const playbackVoiceAssignments = (
  characters: Character[],
  assignedVoices: Record<string, string>,
  previewVoiceId: string,
): Record<string, string> => {
  const resolved = { ...assignedVoices };
  const fallbackVoiceId = previewVoiceId.trim();

  if (!fallbackVoiceId) return resolved;

  characters.forEach((character) => {
    if (
      character.name !== "SCREENPLAY_SEQUENCE" &&
      !resolved[character.name]?.trim()
    ) {
      resolved[character.name] = fallbackVoiceId;
    }
  });

  return resolved;
};
